import Button from "@/shared/form/button";
import { DYNAMIC_PROCESS_TABS } from "./dynamic-process-tabs-enum";
import { useTabs } from "./dynamic-process-tabs-context";
import { useTranslations } from "use-intl";

export function DynamicProcessTabsButton({
  step,
  next,
  prev,
}: {
  step: DYNAMIC_PROCESS_TABS;
  next?: boolean;
  prev?: boolean;
}) {
  const t = useTranslations("DynamicProcesses");
  const { setStep } = useTabs();

  return (
    <Button type="primary" onClick={() => setStep(step)}>
      {next && t("DYNAMIC_PROCESS_TABS_NEXT")}
      {prev && t("DYNAMIC_PROCESS_TABS_PREVIOUS")}
    </Button>
  );
}
